import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { PermissionDatasource } from '../../infra/datasource/PermissionDatasource'

export const permissionDatasourceAdapter: PermissionDatasource = {
  async getUserPermissions(personaId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/profiles/permissions/${personaId}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const data = await response.json()
    return data
  }
}
